(function () {
  'use strict';

  function boot(SID) {
    var BD  = (window.__blogData || {})[SID] || {};
    var SF  = BD.storefront || {};

    var ENDPOINT = SF.endpoint || '';
    var TOKEN    = SF.token    || '';

    if (!ENDPOINT || !TOKEN) {
      console.warn('[FG Blog] No storefront credentials.');
      return;
    }

    /* ── DOM refs ── */
    var meta          = document.getElementById('blog-meta-'            + SID);
    var tabsEl        = document.getElementById('fg-tabs-'              + SID);
    var grid          = document.getElementById('fg-grid-'              + SID);
    var paginEl       = document.getElementById('fg-pagination-'        + SID);
    var loaderEl      = document.getElementById('fg-loader-'            + SID);
    var searchGrid    = document.getElementById('fg-search-grid-'       + SID);
    var searchLoader  = document.getElementById('fg-search-loader-'     + SID);
    var searchPaginEl = document.getElementById('fg-search-pagination-' + SID);
    var sInput        = document.getElementById('fg-search-'            + SID);
    var sBtn          = document.getElementById('fg-search-btn-'        + SID);
    var originalGrid  = document.getElementById('original-grid-'        + SID);
    var nativePaginEl = document.getElementById('fg-native-pagination-' + SID);
    var bpList        = document.querySelector('blog-posts-list[section-id="' + SID + '"]');
    var jsSlider      = document.getElementById('fg-latest-js-'         + SID);
    var jsSliderWrap  = document.getElementById('fg-latest-js-wrapper-' + SID);
    var jsSliderPagi  = document.getElementById('fg-latest-js-pagi-'    + SID);

    if (!meta || !grid) return;

    var IS_VIEW_ALL     = meta.dataset.isViewAll === 'true';
    var HAS_ARTICLES    = meta.dataset.hasArticles === 'true'
                        || !!(originalGrid && originalGrid.querySelector('.blog-post-item'));
    var VIEW_ALL_HANDLE = meta.dataset.viewAllHandle || 'view-all';
    var VIEW_ALL_LABEL  = meta.dataset.viewAllLabel  || 'View All';
    var PER_PAGE        = 12;
    var urlPage         = parseInt((location.search.match(/[?&]page=(\d+)/) || [])[1], 10) || 1;

    /* ── localStorage cache helpers ── */
    var CACHE_NS       = 'fg_blog_' + SID + '_';
    var CACHE_TTL_PAGE = 3  * 60 * 1000;  /* 3 min  — article pages */
    var CACHE_TTL_SCAN = 30 * 60 * 1000;  /* 30 min — total count   */

    function cacheGet(key) {
      try {
        var raw = localStorage.getItem(CACHE_NS + key);
        if (!raw) return null;
        var obj = JSON.parse(raw);
        if (Date.now() - obj.t > obj.ttl) { localStorage.removeItem(CACHE_NS + key); return null; }
        return obj.v;
      } catch(e) { return null; }
    }

    function cacheSet(key, val, ttl) {
      try { localStorage.setItem(CACHE_NS + key, JSON.stringify({ t: Date.now(), ttl: ttl, v: val })); } catch(e) {}
    }

    /* ── AbortController for search ── */
    var searchAbort = null;

    /* ── Pagination state ── */
    var pageCursors   = { 1: null }; /* pageCursors[page] = afterCursor (null = page 1) */
    var vaTotalPages  = 0;           /* 0 = unknown until background scan completes */
    var vaCurrentPage = 1;
    var vaLoading     = false;
    var scanDone      = false;
    var lastHasNext   = false;

    /* Restore cached total + page cursors — skips expensive scan on repeat loads */
    var _ct = cacheGet('total');
    var _cc = cacheGet('cursors');
    if (_ct) { vaTotalPages = _ct; scanDone = true; }
    if (_cc && typeof _cc === 'object') {
      Object.keys(_cc).forEach(function (k) {
        if (pageCursors[k] === undefined) pageCursors[k] = _cc[k];
      });
    }

    /* ── Search state ── */
    var searchQuery   = '';
    var searchResults = [];
    var searchPage    = 1;
    var searchTotal   = 1;

    /* ── Read-more link (passed via window.__blogData from Liquid) ── */
    var READ_MORE_LABEL = BD.readMoreLabel || 'Read more';
    var READ_MORE_ARROW = BD.readMoreArrow || '';
    var READ_MORE_HTML  = '<span>' + READ_MORE_LABEL + '</span>'
                        + '<span class="svg-wrapper icon-arrow">' + READ_MORE_ARROW + '</span>';

    /* ════════════════════════════════════════
      VISIBILITY HELPERS
      removeProperty clears inline style="display:none"
      even when overridden with !important
    ════════════════════════════════════════ */
    function elShow(el) { if (el) el.style.removeProperty('display'); }
    function elHide(el) { if (el) el.style.setProperty('display', 'none', 'important'); }

    function modeViewAll() {
      elShow(grid);
      elHide(originalGrid);
      elHide(nativePaginEl);
      elHide(searchGrid);
      elHide(searchPaginEl);
      elHide(searchLoader);
    }

    function modeOriginal() {
      elHide(grid); elHide(paginEl); elHide(loaderEl);
      elShow(bpList);
      elShow(originalGrid);
      elHide(searchGrid); elHide(searchPaginEl); elHide(searchLoader);
    }

    function modeSearch() {
      elHide(grid); elHide(paginEl); elHide(loaderEl);
      elHide(originalGrid);
      elHide(nativePaginEl);
      elShow(searchGrid);
    }

    /* ════════════════════════════════════════
      LOADER
    ════════════════════════════════════════ */
    function showLoader(ldr, content) {
      if (ldr)     ldr.style.removeProperty('display');
      if (content) content.style.opacity = '0.35';
    }

    function hideLoader(ldr, content) {
      if (ldr)     ldr.style.setProperty('display', 'none', 'important');
      if (content) content.style.removeProperty('opacity');
    }

    /* ════════════════════════════════════════
      STOREFRONT GQL
    ════════════════════════════════════════ */
    function sfFetch(query, vars) {
      return fetch(ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': TOKEN
        },
        body: JSON.stringify(vars ? { query: query, variables: vars } : { query: query })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (j) {
        if (j.errors && j.errors.length) throw new Error(j.errors[0].message);
        return j;
      });
    }

    /* ════════════════════════════════════════
      TABS
    ════════════════════════════════════════ */
    function loadTabs() {
      if (!tabsEl) return;
      tabsEl.innerHTML = [80,140,155,120,145,110,165,130,100,150].map(function (w) {
        return '<span class="fg-tab-skeleton" style="width:' + w + 'px"></span>';
      }).join('');

      sfFetch('{ blogs(first:50){ edges{ node{ title handle onlineStoreUrl } } } }')
        .then(function (j) {
          renderTabs((j.data.blogs.edges || []).map(function (e) { return e.node; }));
        })
        .catch(function () {
          renderTabs(Object.entries(BD.tagsByBlog || {}).map(function (kv) {
            return { handle: kv[0], title: kv[1].title, onlineStoreUrl: kv[1].url || '/blogs/' + kv[0] };
          }));
        });
    }

    function renderTabs(blogs) {
      if (!tabsEl) return;
      var va      = blogs.find(function (b) { return b.handle === VIEW_ALL_HANDLE; });
      var others  = blogs.filter(function (b) { return b.handle !== VIEW_ALL_HANDLE; })
                        .sort(function (a, b) { return a.title.localeCompare(b.title); });
      var ordered = va ? [va].concat(others) : others;
      var cur     = tabsEl.dataset.current;

      tabsEl.innerHTML = ordered.map(function (b) {
        var active = b.handle === cur;
        var label  = b.handle === VIEW_ALL_HANDLE ? VIEW_ALL_LABEL : b.title;
        var url    = b.onlineStoreUrl || '/blogs/' + b.handle;
        return '<a href="' + esc(url) + '" class="fg-tab' + (active ? ' fg-tab--active' : '') + '"'
            + (active ? ' aria-current="page"' : '') + '>' + esc(label) + '</a>';
      }).join('');
    }

    /* ════════════════════════════════════════
      GQL QUERIES
      Global articles() — works without per-blog
      permissions. View-all aggregator excluded JS-side.
    ════════════════════════════════════════ */
    /* Fields needed to render cards identically to Horizon blog-post-card */
    var AF = 'id title handle publishedAt authorV2 { name } excerpt content(truncateAt: 220) image{url altText} blog{handle title}';

    var GQL_PAGE = [
      'query FgPage($n:Int!,$a:String){',
      '  articles(first:$n,after:$a,sortKey:PUBLISHED_AT,reverse:true){',
      '    edges{ node{' + AF + '} cursor }',
      '    pageInfo{ hasNextPage endCursor }}}'
    ].join('');

    var GQL_SCAN = [
      'query FgScan($n:Int!,$a:String){',
      '  articles(first:$n,after:$a,sortKey:PUBLISHED_AT,reverse:true){',
      '    edges{ cursor node{ blog{ handle } } }',
      '    pageInfo{ hasNextPage endCursor }}}'
    ].join('');

    /* ════════════════════════════════════════
      LATEST ARTICLES SLIDER (View-All only)
      Single global query — 3 newest articles
    ════════════════════════════════════════ */
    function loadLatestSlider() {
      if (!jsSlider || !jsSliderWrap) return;

      sfFetch(
        'query FgLatest($n:Int!){ articles(first:$n,sortKey:PUBLISHED_AT,reverse:true){ edges{ node{' + AF + '} } } }',
        { n: 10 }
      )
      .then(function (json) {
        var edges = (json.data && json.data.articles && json.data.articles.edges) || [];
        var top3  = edges
          .filter(function (e) { return !e.node.blog || e.node.blog.handle !== VIEW_ALL_HANDLE; })
          .slice(0, 3)
          .map(function (e) { return e.node; });
        renderLatestSlider(top3);
      })
      .catch(function (e) {
        console.warn('[FG Blog] latest slider:', e.message);
        elHide(jsSlider);
      });
    }

    function renderLatestSlider(articles) {
      if (!jsSlider || !jsSliderWrap || !articles.length) { elHide(jsSlider); return; }

      jsSliderWrap.innerHTML = articles.map(function (a) {
        var url       = '/blogs/' + ((a.blog && a.blog.handle) || 'news') + '/' + (a.handle || '');
        var img       = a.image ? a.image.url : '';
        var imgAlt    = (a.image && a.image.altText) ? a.image.altText : esc(a.title || '');
        var date      = fmtDate(a.publishedAt);
        var blogAuthor = (a.authorV2 && a.authorV2.name) ? a.authorV2.name : '';
        var ex        = (a.excerpt || a.content || '').substring(0, 200);
        if ((a.content || '').length > 200) ex += '…';

        var metaHtml = (date || blogAuthor)
          ? '<p class="blog-post-details spacing-style justify-left">'
            + (date ? '<span class="blog-post-card__date">' + date + '</span>' : '')
            + (date && blogAuthor ? '<span class="blog-post-card__meta-sep" aria-hidden="true">|</span>' : '')
            + (blogAuthor ? '<span class="blog-post-card__blog-author">' + esc(blogAuthor) + '</span>' : '')
            + '</p>'
          : '';

        var imgHtml = img
          ? '<div class="blog-post-card__image-container blog-post-card__image--large">'
            + '<a href="' + esc(url) + '" class="blog-post-card__image-link" tabindex="-1" aria-hidden="true">'
            + '<img src="' + esc(img) + '&width=900"'
            + ' srcset="' + esc(img) + '&width=400 400w,' + esc(img) + '&width=900 900w"'
            + ' sizes="(min-width:767px) 45vw, 100vw"'
            + ' alt="' + imgAlt + '" loading="eager" width="900" height="675"'
            + ' class="blog-post-card__image"/>'
            + '</a>'
            + '</div>'
          : '';

        var contentHtml = '<div class="blog-post-card__content">'
          + metaHtml
          + '<div class="text-block">'
          + '<a href="' + esc(url) + '" class="blog-post-card__title-link">' + esc(a.title || 'Untitled') + '</a>'
          + '</div>'
          + '<p class="blog-post-card__content-text">' + esc(ex) + '</p>'
          + '<a href="' + esc(url) + '" class="blog-read-more">' + READ_MORE_HTML + '</a>'
          + '</div>';

        return '<div class="blog-post-item swiper-slide">'
          + '<div class="blog-post-card">'
          + imgHtml
          + contentHtml
          + '</div>'
          + '</div>';
      }).join('');

      jsSlider.classList.remove('fg-hidden');
      jsSlider.style.removeProperty('display');

      window.fgLoadSwiper().then(function () {
        new Swiper(jsSlider, {
          slidesPerView: 1, spaceBetween: 20, autoHeight: true, navigation: false,
          pagination: {
            el: jsSliderPagi, clickable: true,
            renderBullet: function (i, c) { return '<span class="' + c + '">' + (i + 1) + '</span>'; }
          }
        });
      });
    }

    /* ════════════════════════════════════════
      VIEW-ALL: FETCH ONE PAGE
      Single API call, O(PER_PAGE) data transfer.
      Stores endCursor for next page navigation.
    ════════════════════════════════════════ */
    function fetchViewAllPage(page) {
      var afterCursor = pageCursors[page] || null;

      return sfFetch(GQL_PAGE, { n: PER_PAGE + 5, a: afterCursor })
        .then(function (json) {
          var data = json.data && json.data.articles;
          if (!data) throw new Error('No articles data returned');

          var edges    = data.edges || [];
          /* Exclude any articles that belong to the view-all aggregator blog */
          var filtered = edges.filter(function (e) {
            return !e.node.blog || e.node.blog.handle !== VIEW_ALL_HANDLE;
          });
          var slice    = filtered.slice(0, PER_PAGE);

          /* Store cursor for next page */
          if (slice.length > 0 && data.pageInfo.hasNextPage) {
            var lastEdge = edges[edges.length - 1];
            if (lastEdge && lastEdge.cursor) pageCursors[page + 1] = lastEdge.cursor;
          }

          var _result = {
            articles: slice.map(function (e) { return e.node; }),
            hasNext:  data.pageInfo.hasNextPage
          };
          if (page === 1) cacheSet('p1', _result, CACHE_TTL_PAGE);
          return _result;
        });
    }

    /* ════════════════════════════════════════
      BACKGROUND SCAN — builds full pageCursors map
      Uses same batch size + filter as fetchViewAllPage
      so stored cursors are directly usable for navigation.
      Runs 800ms after first render so page 1 appears fast.
    ════════════════════════════════════════ */
    function runBackgroundScan() {
      var safety = 0;

      function scanPage(after, pageNum) {
        return sfFetch(GQL_SCAN, { n: PER_PAGE + 5, a: after }).then(function (json) {
          var data = json.data && json.data.articles;
          if (!data) return pageNum;

          var edges    = data.edges || [];
          var filtered = edges.filter(function (e) {
            return !e.node || !e.node.blog || e.node.blog.handle !== VIEW_ALL_HANDLE;
          });
          var hasMore  = data.pageInfo.hasNextPage;
          var lastEdge = edges.length ? edges[edges.length - 1] : null;

          if (filtered.length >= PER_PAGE && hasMore && lastEdge && ++safety < 200) {
            var nextPage = pageNum + 1;
            if (pageCursors[nextPage] === undefined) {
              pageCursors[nextPage] = lastEdge.cursor;
            }
            return scanPage(lastEdge.cursor, nextPage);
          }
          return filtered.length > 0 ? pageNum : Math.max(1, pageNum - 1);
        });
      }

      scanPage(null, 1)
        .then(function (total) {
          vaTotalPages = Math.max(1, total);
          scanDone     = true;
          cacheSet('total',   vaTotalPages, CACHE_TTL_SCAN);
          cacheSet('cursors', pageCursors,  CACHE_TTL_SCAN);
          if (!searchQuery) buildViewAllPagination(lastHasNext);
        })
        .catch(function (e) { console.warn('[FG Blog] scan:', e.message); });
    }

    /* ════════════════════════════════════════
      CURSOR PREFETCH — sequential walk to build
      missing cursors when user jumps to a page
      whose cursor was not yet populated by scan.
    ════════════════════════════════════════ */
    function ensureCursorForPage(page) {
      if (page <= 1 || pageCursors[page] !== undefined) return Promise.resolve();

      /* Find the highest page we already have a cursor for */
      var from = 1;
      for (var p = 2; p < page; p++) {
        if (pageCursors[p] !== undefined) from = p; else break;
      }

      var safety = 0;
      function chain(fromPage) {
        if (pageCursors[page] !== undefined) return Promise.resolve();
        if (++safety > 50) return Promise.reject(new Error('cursor chain limit'));
        return sfFetch(GQL_SCAN, { n: PER_PAGE + 5, a: pageCursors[fromPage] || null })
          .then(function (json) {
            var data = json.data && json.data.articles;
            if (!data) return;
            var edges    = data.edges || [];
            var filtered = edges.filter(function (e) {
              return !e.node || !e.node.blog || e.node.blog.handle !== VIEW_ALL_HANDLE;
            });
            var lastEdge = edges.length ? edges[edges.length - 1] : null;
            if (filtered.length >= PER_PAGE && data.pageInfo.hasNextPage && lastEdge) {
              var next = fromPage + 1;
              if (pageCursors[next] === undefined) pageCursors[next] = lastEdge.cursor;
              if (next < page) return chain(next);
            }
          });
      }
      return chain(from);
    }

    /* ════════════════════════════════════════
      LOAD PAGE
    ════════════════════════════════════════ */
    function loadViewAllPage(page) {
      if (vaLoading) return;
      vaLoading     = true;
      vaCurrentPage = page;

      var newUrl = page > 1 ? location.pathname + '?page=' + page : location.pathname;
      history.pushState({ fgPage: page }, '', newUrl);
      if (paginEl) paginEl.classList.add('fg-pagination-wrap--loading');

      showLoader(loaderEl, grid);
      modeViewAll();
      renderSkeletons(grid, PER_PAGE);

      ensureCursorForPage(page)
        .then(function () { return fetchViewAllPage(page); })
        .then(function (r) {
          lastHasNext = r.hasNext;
          renderCards(r.articles, grid, true);
          if (!scanDone) vaTotalPages = r.hasNext ? page + 1 : page;
          buildViewAllPagination(r.hasNext);
          elShow(paginEl);
        })
        .catch(function (err) {
          console.error('[FG Blog] loadViewAllPage:', err.message);
          grid.innerHTML = errorHtml(err.message);
          elHide(paginEl);
        })
        .finally(function () {
          hideLoader(loaderEl, grid);
          if (paginEl) paginEl.classList.remove('fg-pagination-wrap--loading');
          vaLoading = false;
        });
    }

    /* ════════════════════════════════════════
      PAGINATION UI
      Progressive: ←/→ appears immediately;
      numbered pages appear after scan finishes.
    ════════════════════════════════════════ */
    function buildViewAllPagination(hasNextOverride) {
      if (!paginEl) return;
      paginEl.innerHTML = '';

      var cp      = vaCurrentPage;
      var tp      = vaTotalPages;
      var hasNext = (typeof hasNextOverride === 'boolean') ? hasNextOverride : (cp < tp);
      var hasPrev = cp > 1;

      if (!hasPrev && !hasNext) { elHide(paginEl); return; }

      var nav = document.createElement('div');
      nav.className = 'fg-pagination';

      nav.appendChild(mkArrow(SVG_PREV, 'Previous page', !hasPrev, function () {
        loadViewAllPage(cp - 1); scrollToEl(grid);
      }));

      if (scanDone && tp > 1) {
        calcPageWindow(cp, tp).forEach(function (n, idx, arr) {
          if (idx > 0 && n - arr[idx - 1] > 1) nav.appendChild(mkDots());
          (function (pn) {
            nav.appendChild(mkNum(pn, cp, function () {
              if (pn !== cp) { loadViewAllPage(pn); scrollToEl(grid); }
            }));
          }(n));
        });
      } else {
        nav.appendChild(mkNum(cp, cp, null)); /* scan in progress — just show current page */
      }

      nav.appendChild(mkArrow(SVG_NEXT, 'Next page', !hasNext, function () {
        loadViewAllPage(cp + 1); scrollToEl(grid);
      }));

      paginEl.appendChild(nav);
      elShow(paginEl);
    }

    /* ════════════════════════════════════════
      SEARCH
    ════════════════════════════════════════ */
    function doSearch(q) {
      if (searchAbort) { try { searchAbort.abort(); } catch(e) {} }
      searchAbort = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      var signal  = searchAbort ? { signal: searchAbort.signal } : {};

      modeSearch();
      showLoader(searchLoader, searchGrid);
      renderSkeletons(searchGrid, 6);

      fetch('/search/suggest.json?q=' + encodeURIComponent(q)
          + '&resources[type]=article&resources[options][fields]=title,body,tag,author&resources[limit]=200', signal)
        .then(function (r) { if (!r.ok) throw new Error('Search ' + r.status); return r.json(); })
        .then(function (data) {
          searchResults = (data.resources && data.resources.results && data.resources.results.articles) || [];
          searchResults.sort(function (a, b) {
            return new Date(b.published_at || 0) - new Date(a.published_at || 0);
          });
          searchPage    = 1;
          searchTotal   = Math.max(1, Math.ceil(searchResults.length / PER_PAGE));
          renderSearchSlice();
        })
        .catch(function (e) {
          if (e.name === 'AbortError') return;
          if (searchGrid) searchGrid.innerHTML = errorHtml(e.message);
          if (searchPaginEl) searchPaginEl.innerHTML = '';
        })
        .finally(function () { hideLoader(searchLoader, searchGrid); });
    }

    function renderSearchSlice() {
      if (!searchGrid || !searchPaginEl) return;
      var slice = searchResults.slice((searchPage - 1) * PER_PAGE, searchPage * PER_PAGE);
      searchGrid.innerHTML = '';
      if (!slice.length) {
        searchGrid.innerHTML = '<div class="fg-empty"><p>No articles found for <strong>'
          + esc(searchQuery) + '</strong>.</p></div>';
        elHide(searchPaginEl); return;
      }
      var frag = document.createDocumentFragment();
      slice.forEach(function (a, i) { frag.appendChild(buildCard(a, false, i + 1)); });
      searchGrid.appendChild(frag);
      buildSearchPagination();
      elShow(searchGrid);
    }

    function buildSearchPagination() {
      if (!searchPaginEl) return;
      searchPaginEl.innerHTML = '';
      var cp = searchPage, tp = searchTotal;
      if (tp <= 1) { elHide(searchPaginEl); return; }

      var nav = document.createElement('div');
      nav.className = 'fg-pagination';
      nav.appendChild(mkArrow(SVG_PREV, 'Previous page', cp <= 1, function () {
        searchPage--; renderSearchSlice(); scrollToEl(searchGrid);
      }));
      calcPageWindow(cp, tp).forEach(function (n, idx, arr) {
        if (idx > 0 && n - arr[idx - 1] > 1) nav.appendChild(mkDots());
        (function (pn) {
          nav.appendChild(mkNum(pn, cp, function () {
            if (pn !== cp) { searchPage = pn; renderSearchSlice(); scrollToEl(searchGrid); }
          }));
        }(n));
      });
      nav.appendChild(mkArrow(SVG_NEXT, 'Next page', cp >= tp, function () {
        searchPage++; renderSearchSlice(); scrollToEl(searchGrid);
      }));
      searchPaginEl.appendChild(nav);
      elShow(searchPaginEl);
    }

    /* ════════════════════════════════════════
      CARD RENDERING
      buildCard output mirrors Horizon blog-post-card:
        image → date | blog name → title → excerpt → Read more
    ════════════════════════════════════════ */
    function renderSkeletons(target, count) {
      target.innerHTML = '';
      var frag = document.createDocumentFragment();
      for (var i = 0; i < count; i++) {
        var d = document.createElement('div');
        d.className = 'blog-post-item fg-card-skeleton';
        // d.setAttribute('style', '--col-span: 2; --blog-post-card-scale: 0.6;');
        d.innerHTML = '<div class="fg-sk-box"></div>'
          + '<div class="fg-sk-line fg-sk-line--title"></div>'
          + '<div class="fg-sk-line"></div>'
          + '<div class="fg-sk-line"></div>'
          + '<div class="fg-sk-line fg-sk-line--short"></div>';
        frag.appendChild(d);
      }
      target.appendChild(frag);
    }

    function renderCards(articles, target, isGQL) {
      target.innerHTML = '';
      if (!articles.length) {
        target.innerHTML = '<div class="fg-empty"><p>No articles have been published yet.</p></div>';
        return;
      }
      var frag = document.createDocumentFragment();
      articles.forEach(function (a, i) { frag.appendChild(buildCard(a, isGQL, i + 1)); });
      target.appendChild(frag);
    }

    function buildCard(a, isGQL, idx) {
      var title = a.title || 'Untitled';
      var url, imgUrl, imgAlt, publishedAt;

      if (isGQL) {
        var bh   = (a.blog && a.blog.handle) ? a.blog.handle : 'news';
        url         = '/blogs/' + bh + '/' + (a.handle || '');
        imgUrl      = (a.image && a.image.url)     ? a.image.url     : null;
        imgAlt      = (a.image && a.image.altText) ? a.image.altText : title;
        publishedAt = a.publishedAt || '';
      } else {
        url         = a.url || '#';
        imgUrl      = typeof a.featured_image === 'string'
                    ? a.featured_image
                    : (a.featured_image ? (a.featured_image.url || a.featured_image.src || null) : null);
        imgAlt      = title;
        publishedAt = a.published_at || '';
      }

      var date = fmtDate(publishedAt);

      var ex = (a.summary || a.excerpt || a.content || a.body || '')
                 .replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
      if (ex.length > 165) ex = ex.substring(0, 165).trimEnd() + '…';

      var imgHtml = imgUrl
        ? '<div class="blog-post-card__image-container">'
          + '<a href="' + esc(url) + '">'
          + '<img src="' + esc(imgUrl) + (isGQL ? '&width=800' : '') + '"'
          + ' srcset="' + esc(imgUrl) + (isGQL ? '&width=400' : '') + ' 400w,'
          + esc(imgUrl) + (isGQL ? '&width=800' : '') + ' 800w"'
          + ' alt="' + esc(imgAlt) + '" loading="lazy" width="800" height="600"'
          + ' class="border-style blog-post-card__image blog-post-card__image--medium"'
          + ' style="--border-width: 1px; --border-style: none; --border-color: rgb(var(--color-border-rgb) / 1.0); --border-radius: 20px; overflow: hidden;">'
          + '</a>'
          + '</div>'
        : '';

      var dateHtml = date
        ? '<div class="blog-post-details spacing-style justify-left paragraph" style="--padding-block-start: 15px; --padding-block-end: 0px;">'
          + '<span><time datetime="' + esc(publishedAt) + '">' + date + '</time></span>'
          + '</div>'
        : '';

      var titleStyle = '--padding-block-start: 0px; --padding-block-end: 10px; --padding-inline-start: 0px; --padding-inline-end: 0px;'
        + ' --color: var(--color-foreground); --font-size: 1.5rem;'
        + ' --font-weight: var(--font-accent--weight); --font-family: var(--font-accent--family);'
        + ' --text-transform: none; --text-wrap: pretty;'
        + ' --line-height: var(--line-height--body-normal); --letter-spacing: var(--letter-spacing--body-normal);'
        + ' --width: 100%; --text-align: left;';

      var contentStyle = '--padding-block-start: 0px; --padding-block-end: 0px; --padding-inline-start: 0px; --padding-inline-end: 0px;'
        + ' --color: var(--color-foreground); --font-size: 1.0625rem;'
        + ' --font-weight: var(--font-body--weight); --font-family: var(--font-body--family);'
        + ' --text-transform: none; --text-wrap: pretty;'
        + ' --line-height: var(--line-height--body-normal); --letter-spacing: var(--letter-spacing--body-normal);';

      var div = document.createElement('div');
      div.className = 'blog-post-item';
      div.setAttribute('data-testid', 'blog-post-item');
      // div.setAttribute('style', '--col-span: 2; --blog-post-card-scale: 0.6;');
      if (idx !== undefined) div.setAttribute('data-blog-index', SID + '-' + idx);

      div.innerHTML =
        '<div class="blog-post-card" style="--text-align: left">'
        + imgHtml
        + '<div class="blog-post-card__content">'
        + dateHtml
        + '<a href="' + esc(url) + '" data-testid="blog-post-link">'
        + '<div class="spacing-style text-block custom text-block--align-left custom-typography custom-font-size custom-color" style="' + titleStyle + '">'
        + esc(title)
        + '</div>'
        + '</a>'
        + '<div class="blog-post-card__content-text spacing-style text-block custom custom-typography custom-font-size custom-color" style="' + contentStyle + '">'
        + esc(ex)
        + '<a href="' + esc(url) + '" class="blog-read-more">' + READ_MORE_HTML + '</a>'
        + '</div>'
        + '</div>'
        + '</div>';

      return div;
    }

    /* ════════════════════════════════════════
      PAGINATION ELEMENT BUILDERS
    ════════════════════════════════════════ */
    var SVG_PREV = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>';
    var SVG_NEXT = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>';

    function mkArrow(svg, label, disabled, onClick) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fg-pg-btn is-arrow' + (disabled ? ' is-disabled' : '');
      b.disabled  = disabled;
      b.setAttribute('aria-label', label);
      b.innerHTML = svg;
      if (!disabled && onClick) b.addEventListener('click', onClick);
      return b;
    }

    function mkNum(n, cur, onClick) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className   = 'fg-pg-btn' + (n === cur ? ' is-current' : '');
      b.textContent = String(n);
      if (n === cur) { b.setAttribute('aria-current', 'page'); b.disabled = true; return b; }
      if (onClick) b.addEventListener('click', onClick);
      return b;
    }

    function mkDots() {
      var s = document.createElement('span');
      s.className = 'fg-pg-ellipsis'; s.textContent = '…';
      s.setAttribute('aria-hidden', 'true');
      return s;
    }

    function calcPageWindow(cur, total) {
      if (total <= 7) { var r = []; for (var i = 1; i <= total; i++) r.push(i); return r; }
      var s = new Set([1, total]);
      for (var i = Math.max(1, cur - 2); i <= Math.min(total, cur + 2); i++) s.add(i);
      return Array.from(s).sort(function (a, b) { return a - b; });
    }

    /* ════════════════════════════════════════
      SEARCH INPUT HANDLER
    ════════════════════════════════════════ */
    function handleSearch() {
      var q = (sInput ? sInput.value : '').trim();
      searchQuery = q;
      if (q) {
        searchPage = 1; doSearch(q);
      } else {
        searchResults = []; searchTotal = 1;
        if (searchGrid)    searchGrid.innerHTML    = '';
        if (searchPaginEl) searchPaginEl.innerHTML = '';
        elHide(searchGrid); elHide(searchPaginEl);
        if (IS_VIEW_ALL) { modeViewAll(); loadViewAllPage(vaCurrentPage || 1); }
        else { modeOriginal(); }
      }
    }

    if (sBtn)   sBtn.addEventListener('click', handleSearch);
    if (sInput) sInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); handleSearch(); }
    });

    document.addEventListener('fg:search', function (e) {
      var q = ((e.detail && e.detail.query) || '').trim();
      if (sInput) sInput.value = q;
      searchQuery = q;
      if (q) {
        searchPage = 1;
        doSearch(q);
      } else {
        searchResults = []; searchTotal = 1;
        if (searchGrid)    searchGrid.innerHTML    = '';
        if (searchPaginEl) searchPaginEl.innerHTML = '';
        elHide(searchGrid); elHide(searchPaginEl);
        if (IS_VIEW_ALL) { modeViewAll(); loadViewAllPage(vaCurrentPage || 1); }
        else { modeOriginal(); }
      }
    });

    /* ════════════════════════════════════════
      UTILITIES
    ════════════════════════════════════════ */
    function esc(s) {
      return String(s)
        .replace(/&/g,'&amp;').replace(/</g,'&lt;')
        .replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
    }

    function fmtDate(s) {
      if (!s) return '';
      try { return new Date(s).toLocaleDateString('en-US',{year:'numeric',month:'long',day:'numeric'}); }
      catch(_) { return ''; }
    }

    function errorHtml(msg) {
      return '<div class="fg-error-state">'
        + '<p>Could not load articles. Please try refreshing.</p>'
        + '<p style="font-size:.75rem;color:#aaa;margin-top:4px;">' + esc(String(msg)) + '</p>'
        + '<button type="button" onclick="location.reload()">Refresh</button>'
        + '</div>';
    }

    function scrollToEl(el) { if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }

    /* ════════════════════════════════════════
      INIT
    ════════════════════════════════════════ */
    history.replaceState({ fgPage: urlPage }, '', location.href);
    window.addEventListener('popstate', function (e) {
      if (!IS_VIEW_ALL) return;
      var p = (e.state && e.state.fgPage) || 1;
      loadViewAllPage(p);
    });

    loadTabs();

    if (IS_VIEW_ALL) {
      modeViewAll();
      elHide(paginEl);

      var _cachedP1 = cacheGet('p1');
      if (_cachedP1 && urlPage === 1) {
        /* Instant render from cache; refresh silently in background */
        renderCards(_cachedP1.articles, grid, true);
        lastHasNext = _cachedP1.hasNext;
        if (!scanDone) vaTotalPages = _cachedP1.hasNext ? 2 : 1;
        buildViewAllPagination(_cachedP1.hasNext);
        elShow(paginEl);
        fetchViewAllPage(1).then(function(r) {
          lastHasNext = r.hasNext;
          renderCards(r.articles, grid, true);
          buildViewAllPagination(r.hasNext);
        }).catch(function() {});
      } else {
        /* Cold load: skeleton → fetch (deep-link or no cache) */
        renderSkeletons(grid, PER_PAGE);
        showLoader(loaderEl, grid);
        loadViewAllPage(urlPage);
      }

      /* Latest slider (parallel, non-blocking) */
      loadLatestSlider();

      /* Background count scan — skipped if total was restored from cache */
      if (!scanDone) setTimeout(runBackgroundScan, 800);

    } else {
      if (HAS_ARTICLES) {
        modeOriginal();
      } else {
        elHide(bpList);
        grid.innerHTML = '<div class="fg-empty"><p>No articles have been published in this category yet.</p></div>';
        elShow(grid);
      }
    }
  }

  window.FGBlogBoot = boot;
})();
